var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessStepDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7652 0.22934C16.0779 0.535488 16.0783 1.03226 15.7662 1.33892L6.16616 10.7697C6.01617 10.9171 5.81262 10.9999 5.60033 11C5.38804 11.0001 5.18443 10.9174 5.03431 10.7702L0.234315 6.06264C-0.0781049 5.75623 -0.0781049 5.25946 0.234315 4.95305C0.546734 4.64665 1.05327 4.64665 1.36569 4.95305L5.59953 9.10536L14.6338 0.230264C14.946 -0.0763935 15.4525 -0.0768072 15.7652 0.22934Z",
    fill: "#8FDBAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessStepDone);
export default __webpack_public_path__ + "static/media/process_step_done.5b77a2398ac6378ec44bdfda0c66df25.svg";
export { ForwardRef as ReactComponent };